export default "__VITE_ASSET__BKhZNun0__"